module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#strategy",
      toString: function () {
        return this.url;
      }
    }